export * from './handleEvents'
export * from './load'
export * from './replace'
import { setupReplace } from './load'
import { initOptions, log, updateOptions } from '@tr-infra/pilot-core'
import { _global } from '@tr-infra/pilot-utils'
import { SDK_VERSION, SDK_NAME } from '@tr-infra/pilot-shared'
import { InitOptions } from '@tr-infra/pilot-types'
function webInit(options: InitOptions = {}): void {
  if (!('XMLHttpRequest' in _global) || options.disabled) return
  initOptions(options)
  setupReplace()
}

function init(options: InitOptions = {}): void {
  webInit(options)
}

function setOptions(options: InitOptions = {}): void {
  updateOptions(options)
}

export { SDK_VERSION, SDK_NAME, init, log, setOptions }
